import { Observable } from 'rxjs/Observable';
import {
  RESET_PASSWORD_REQUESTED,
  resetPasswordSucceeded,
  resetPasswordFailed,
} from '../redux/account';
import { resetPassword } from '../utils/api';

import type { ActionObs, Store, Obs } from '../types';

export default function resetPasswordEpic(
  action$: ActionObs,
  store: Store,
): Obs {
  return action$
    .ofType(RESET_PASSWORD_REQUESTED)
    .switchMap(({ payload: { email } }) =>
      resetPassword({
        email_address: email,
      })
        .map(() => resetPasswordSucceeded())
        .catch(err => {
          return Observable.of(resetPasswordFailed());
        }),
    );
}
